/**
 * Initial width of an image when rendered in SSR. Since SSR can't really know
 * the size of the image element (the bounding box), we can't correctly
 * optimize for it. Meaning, if the width of the image element is 760px,
 * it would be optimal to load a 800px variant of the image, but that's not possible
 * during SSR. Our best approach is running a `useEffect` on the client side and
 * determining the width of the element there.
 */
export const baseImageWidth = 420;

/**
 * Gets an image width based on the width of the element.
 * We can add or remove breakpoints here, but it is always a balance
 * between quality of images and cached points in Cloudinary. So the approach
 * here was to start small.
 * @param elementWidth - The width of the container wrapping the media.
 * @returns A number representing the width of the image that should be requested.
 */
export const getMediaWidthFromElementWidth = (elementWidth: number): number => {
  if (elementWidth > 1600) {
    return 2400;
  }

  if (elementWidth > 1200) {
    return 2000;
  }

  if (elementWidth > 800) {
    return 1600;
  }

  if (elementWidth > 450) {
    return 1000;
  }

  if (elementWidth > 320) {
    return 600;
  }

  return baseImageWidth;
};
